import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleField, LabelWithHelp } from '../../../components';
import { Field } from 'formik';

interface RemindersFormProps {};

function RemindersForm(props: RemindersFormProps) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 space-x-0 lg:space-x-12">
            <div className="flex-1">
                <h2 className="mt-4 mb-1 text-base font-semibold leadin text-lg text-gray-900 dark:text-gray-100">
                    {t('settings.reminders')}
                </h2>
                <div className="mt-5">
                    <LabelWithHelp htmlFor="api_url" help={t('settings.help.reminders_frequency') || ''}>
                        {t('settings.reminders_frequency')}
                    </LabelWithHelp>
                    <div className="mt-2">
                        <Field
                            type="text"
                            name="reminders.frequency"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="0 9 * * 1-5"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RemindersForm;
